import { create } from 'zustand'
import { accountsApi } from '@/api'
import type { AccountWithStats } from '@olimhub/shared'

interface SuggestionsState {
  suggestions: AccountWithStats[]
  fetched: boolean
  isLoading: boolean
  fetchSuggestions: () => Promise<void>
  removeSuggestion: (id: string) => void
}

export const useSuggestionsStore = create<SuggestionsState>()((set, get) => ({
  suggestions: [],
  fetched: false,
  isLoading: false,

  fetchSuggestions: async () => {
    if (get().fetched || get().isLoading) return
    set({ isLoading: true })
    try {
      const data = await accountsApi.getSuggestions()
      set({ suggestions: data, fetched: true, isLoading: false })
    } catch (err) {
      console.error('[suggestions] fetch failed:', err)
      set({ isLoading: false })
    }
  },

  removeSuggestion: (id) =>
    set((s) => ({ suggestions: s.suggestions.filter((a) => a.id !== id) })),
}))
